import UrlParser from '../routes/url-parser.js';

const RoutingMailPresenter = {

	async init() {
		await this._setView();
		await this._setUpViewMail();
	},

	async _setView() {
		document.getElementById("main-content").style.height = "100vh";
		document.getElementById('main-content').classList.add('bg-gradient-primary');
		document.getElementById("main-content").style.paddingTop = "20px";
		document.getElementById('appbar').classList.add('d-none')
		document.getElementById('accordionSidebar').classList.add('d-none')
		
		document.getElementById("btnBackToLogin").addEventListener("click",()=>{
			this._navigateToLogin()
		})
	},

	async _setUpViewMail(){
		let url = UrlParser.parseActiveUrlWithCombiner();
		if(url == "/already-success-mail"){
			document.getElementById('noteMessage').textContent = 'Email Berhasil diverifikasi';
		}else{
			document.getElementById('noteMessage').textContent = 'Email Sudah diverifikasi';
		}
	},

	_navigateToLogin(){
		window.location.hash = '#/login';
	},
}

export default RoutingMailPresenter;
